import { FocusMonitor } from '@angular/cdk/a11y'
import { Component, ElementRef, OnDestroy, OnInit, Optional, Self, ViewChild } from '@angular/core'
import { FormGroupDirective, NgControl, NgForm, NgModel } from '@angular/forms'
import { MatFormFieldControl } from '@angular/material/form-field'
import { ClinicService, standardizePhone } from '@mmx/shared'
import { MatTelInput } from 'mat-tel-input'

import { CustomMaterialInputControlComponent } from '../custom-field'

@Component({
  selector: 'mmx-phone-field',
  templateUrl: './phone-field.component.html',
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: PhoneFieldComponent,
    },
  ],
  standalone: false,
})
export class PhoneFieldComponent
  extends CustomMaterialInputControlComponent<string>
  implements OnInit, OnDestroy
{
  preferredCountries = ['us', 'ca', 'mx']
  initiallyLoaded = false

  @ViewChild(MatTelInput) private telInput?: MatTelInput

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    @Optional() protected parentForm: NgForm,
    @Optional() protected parentFormGroup: FormGroupDirective,
    protected fm: FocusMonitor,
    protected elRef: ElementRef,
    protected clinicService: ClinicService,
  ) {
    super(ngControl, parentForm, parentFormGroup, fm, elRef)
  }

  get shouldLabelFloat() {
    return true
  }

  override writeValue(value: string) {
    super.writeValue(value)
    // mat-tel-input ignores empty values in its writeValue (the clearing branch is commented
    // out upstream), so a form reset would leave the previous number visible in the input.
    if ((value == null || value === '') && this.telInput != null && this.telInput.phoneNumber !== '') {
      this.telInput.reset()
    }
  }

  get phoneValue(): string | null {
    if (
      typeof this.value === 'string' &&
      this.value.length > 0 &&
      this.value.startsWith('+')
    ) {
      return this.value
    } else {
      return null
    }
  }

  set phoneValue(value: string) { }

  onTextInputChange($event: Event, textInput: any): void {

    // If using ngModel, ontextinputchange fires with a textInput.value = null
    if (this.ngControl instanceof NgModel && !this.initiallyLoaded && !textInput?.value) {
      this.initiallyLoaded = true
      return
    }

    const rawString = textInput.value

    if (rawString) {
      const phone = standardizePhone(rawString)
      if (phone) {
        this.value = phone
      }
    } else {
      this.value = null
    }
  }
}
